import { Users, Clock, BarChart, UserCheck } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


const WhyChooseUs = () => {
  const navigate = useNavigate()
  return (
    <div className="mx-auto max-w-7xl px-4 lg:px-0">
      <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
        <div className="flex flex-col space-y-4 lg:w-1/2">
          <h2 className="text-4xl lg:text-5xl font-semibold text-gray-800 mb-2 lg:leading-relaxed leading-normal text-left">Why choose talentick.ai?</h2>
          <p className="text-gray-700 leading-8 text-left">
            An all-in-one AI-powered platform that simplifies hiring by automating tedious tasks, reducing bias, and delivering precise candidate insights — so you can find the right talent faster and smarter.
          </p>
          <div className="pt-8">
            <button onClick={() => navigate("/register")} className="bg-black text-white px-6 py-3 rounded-full font-medium transition-all hover:scale-110">
              Get Started
            </button>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3.5 md:gap-8 w-full lg:w-1/2 border p-3.5 md:p-8 rounded-xl text-left ">


          <div className="group w-full max-w-sm px-4 py-3 bg-gray-100 rounded-xl hover:bg-[#9AB9B1] hover:shadow-xl transition-all duration-300">
            <div className="flex flex-col">
              <div className="size-12 bg-[#9AB9B1] rounded-full flex items-center justify-center mb-2 group-hover:bg-white text-white">
                <Users className="h-6 w-6  group-hover:text-[#9AB9B1]" />
              </div>
              <div className="mt-2">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 group-hover:text-white">27k</h3>
                <p className="text-gray-600 text-base font-medium mt-1 group-hover:text-white">Users Active</p>
              </div>
            </div>
          </div>

          <div className="group w-full max-w-sm px-4 py-3 bg-gray-100 rounded-xl hover:bg-[#9AB9B1] hover:shadow-xl transition-all duration-300">
            <div className="flex flex-col">
              <div className="size-12 bg-[#9AB9B1] rounded-full flex items-center justify-center mb-2 group-hover:bg-white text-white">
                <Clock className="h-6 w-6  group-hover:text-[#9AB9B1]" />
              </div>
              <div className="mt-2">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 group-hover:text-white">Up to 40%</h3>
                <p className="text-gray-600 text-base font-medium mt-1 group-hover:text-white">Reduce Hiring Time</p>
              </div>
            </div>
          </div>

          <div className="group w-full max-w-sm px-4 py-3 bg-gray-100 rounded-xl hover:bg-[#9AB9B1] hover:shadow-xl transition-all duration-300">
            <div className="flex flex-col">
              <div className="size-12 bg-[#9AB9B1] rounded-full flex items-center justify-center mb-2 group-hover:bg-white text-white">
                <BarChart className="h-6 w-6  group-hover:text-[#9AB9B1]" />
              </div>
              <div className="mt-2">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 group-hover:text-white">70%</h3>
                <p className="text-gray-600 text-base font-medium mt-1 group-hover:text-white">Interview Accuracy</p>
              </div>
            </div>
          </div>
          <div className="group w-full max-w-sm px-4 py-3 bg-gray-100 rounded-xl hover:bg-[#9AB9B1] hover:shadow-xl transition-all duration-300">
            <div className="flex flex-col">
              <div className="size-12 bg-[#9AB9B1] rounded-full flex items-center justify-center mb-2 group-hover:bg-white text-white">
                <UserCheck className="h-6 w-6  group-hover:text-[#9AB9B1]" />
              </div>
              <div className="mt-2">
                <h3 className="text-lg md:text-2xl font-bold text-gray-800 group-hover:text-white">50%</h3>
                <p className="text-gray-600 text-base font-medium mt-1 group-hover:text-white">Employee Rates</p>
              </div>
            </div>
          </div>






        </div>
      </div>
    </div>
  );
}

export default WhyChooseUs